/**
 * User Reports - Reportar errores / feedback desde la plataforma
 */

import { supabase } from "../supabase-client";

export type ReportStatus = "pending" | "reviewed" | "resolved" | "dismissed";

export interface CreateReportInput {
  reportType?: "error" | "bug" | "feedback" | "suggestion";
  subject: string;
  description: string;
  pageUrl?: string;
  errorMessage?: string;
  errorStack?: string;
  userId?: string | null;
}

export async function createUserReport(input: CreateReportInput): Promise<{
  success: boolean;
  id?: string;
  error?: string;
}> {
  try {
    const { data, error } = await supabase
      .from("user_reports")
      .insert({
        user_id: input.userId || null,
        report_type: input.reportType || "error",
        subject: input.subject.trim().slice(0, 500),
        description: input.description.trim().slice(0, 5000),
        page_url: input.pageUrl?.trim().slice(0, 2048) || null,
        error_message: input.errorMessage?.trim().slice(0, 2000) || null,
        error_stack: input.errorStack?.trim().slice(0, 8000) || null,
      })
      .select("id")
      .single();

    if (error) {
      console.error("[user-reports] Insert error:", error);
      return { success: false, error: error.message };
    }
    return { success: true, id: data?.id };
  } catch (err) {
    const msg = err instanceof Error ? err.message : "Unknown error";
    console.error("[user-reports] Exception:", err);
    return { success: false, error: msg };
  }
}

/**
 * Admin: update report status and/or admin notes
 */
export async function updateUserReport(
  reportId: string,
  updates: { status?: ReportStatus; admin_notes?: string }
): Promise<void> {
  const { error } = await supabase
    .from("user_reports")
    .update({
      ...(updates.status && { status: updates.status }),
      ...(updates.admin_notes !== undefined && { admin_notes: updates.admin_notes }),
    })
    .eq("id", reportId);

  if (error) throw error;
}
